export default "__VITE_ASSET__Cx0mDJLA__"